import * as React from 'react';
import { ReactNode } from 'react';
import { ComplexValue, ComponentProps } from 'ui/common';
import { Expandable } from 'ui';
import { ExpandableButtonPosition } from 'ui/expandable/expandable';
import styles from './change-log-link.scss';
import { api } from './api';
import { changeLogContents } from 'app/components/processing-log/change-log-link/change-log-contents';
import { DateFormatters } from 'app/infrastructure/data/types';
import { createFormatters } from 'app/infrastructure/data/date';
import { useEffect, useState } from 'react';
import { CaseLogChanges } from 'app/components/processing-log/change-log-link/types';
export interface ChangeLogLinkProps extends ComponentProps {  
  textDisplayMore?: string;
  textDisplayLess?: string;
  textMessageNoChangesExist?: string;
  textDisclaimer?: string;
  getChangeLog?: (caseLogNo: number) => void;
  caseId?: number;
  primaryKey?: ComplexValue<number>;
  /**
   * @internal
   */
  children?: ReactNode[];
  caseLogXml?: ComplexValue<number>;
  locale?: string;
  changes?: CaseLogChanges[];
}

export const ChangeLogLink = (props: ChangeLogLinkProps) => {

  const [changeLogValues, setChangeLogValues] = useState(null);
  const [isOpened, setIsOpened] = useState(null);
  const canBeDisplayed = !!props.caseLogXml?.value;
  if(!canBeDisplayed) {
    return null;
  }

  const getChangeLog = async() => {
    const changeLog = await api.changeLog(props.caseId, props.primaryKey?.value);
    setChangeLogValues(changeLog);
  };

  useEffect(()=> {
    isOpened && getChangeLog();
  },[isOpened]);

  const expander = (collapsed: boolean) => {
    useEffect(()=> {
      if(!collapsed) {
        setIsOpened(true);
      }
    },[collapsed]);
    
    const hasChildren = props.children && !!React.Children.count(props.children);
    const formatters: DateFormatters = createFormatters(props.locale);
    const changes = props.changes || changeLogValues?.changes;
    const changeLogDetails = changeLogContents(changes, formatters, props.textMessageNoChangesExist);
    const contents = <div className={styles.changeLogContainer}>
                        {hasChildren && <span className={styles.childItems}>{props.children}</span> }
                        <span>{changeLogDetails}</span>
                      </div>;
    
    return !collapsed ? contents : null;
  };

  return (
    <div id={props.componentId} className={styles.buttonContainer}>
      <Expandable
        content={expander}
        useMargin={false}
        buttonPosition={ExpandableButtonPosition.top}
        textDisplayMore={props.textDisplayMore}
        textDisplayLess={props.textDisplayLess} 
        textInfo={props.textDisclaimer}
        useInfoText={true}/>
    </div>
  );
};
